module.exports = __webpack_public_path__ + "img/1_1-parcheggio-0-variante.4bb0d192.png";